import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { appRenameFixed } from "../appRenameFixed";
import { AbilityConfig } from "../ability-config/ability-config";
import { PlatformLocation } from '@angular/common';
var LearningProjectPathComponent = (function () {
    function LearningProjectPathComponent(apiService, commonService, platformLocation, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.route = route;
        this.router = router;
        this.appRename = new appRenameFixed();
        // companyUrl:string = "";
        this.companyLogo = "";
        this.isShowTip = false; //是否显示提示
        this.isShowToast = false; //是否显示toast
        this.isShowQuestionnaire = false; //是否显示问卷
        this.isShowIntroduction = false; //是否显示能力说明
        this.isShowBar = false; //是否显示进度条
        this.questionnaireInfo = null; //问卷信息
        this.courseLockState = null; //测学练考锁住状态
        this.assetsRoute = "../../assets";
        this.results = []; //学习收获
        this.progress = 0; //进度
        this.abilityStatus = 0; //是否完成
        this.canShow = false;
        this.isLocked = true; //强制锁定
        this.progressBarTheme = {
            'name': 'learn',
            'haveTitle': true,
            'color': 'rgb(105,136,238)',
            'radius': '0.2rem'
        }; //主题
        this.desText = '由于升级系统，你需要重新完成<font color="#FFE258">能力诊断</font>，原本学习的数据已被<font color="#FFE258">保留</font>。';
        this.flag = false;
    }
    LearningProjectPathComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.status = 1;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isShowBackBtn();
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        if (this.platformLocation['location']['href'].split('backurl=')[1]) {
            document.cookie = 'backUrl=' + this.platformLocation['location']['href'].split('backurl=')[1];
        }
        this.customerBackUrl = this.commonService.getCookie('backUrl') ? decodeURIComponent(this.commonService.getCookie('backUrl')) : null;
        window.sessionStorage.removeItem('newEdition');
        // this.getThirdCompany();
        this.mengban = false;
        this.sub = this.route.params.subscribe(function (params) {
            _this.learningPathMetaId = params['learningPathMetaId'];
            $('#learningPathMetaIdContainer').val(_this.learningPathMetaId);
            localStorage.setItem('learningPathMetaId', String(_this.learningPathMetaId));
            _this.onceValue = _this.commonService.getOnceValue(_this.learningPathMetaId, 9);
        });
        this.route.queryParams.subscribe(function (res) {
            _this.projectId = res['projectId'];
        });
        //开始记录各能力学习时长
        // localStorage.setItem("learningPathMetaId",this.learningPathMetaId + "");
        // localStorage.setItem("learningPathMetaId-moduleId","-1");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/-1'
        }).subscribe(function (result) { });
        this.results = this.setAssetsResults(this.learningPathMetaId);
        this.getOrCreateLearningPath(this.learningPathMetaId).then(function (result) {
            console.log(result);
            _this.userId = result.userId;
            $('#userIdContainer').val(_this.userId);
            _this.learningPathId = result.id;
            _this.abilityStatus = result.status;
        }).then(function () {
            return _this.commonService.getOnceIno(_this.onceValue).then(function (result) {
                return _this.isShowIntroduction = result === 1 || localStorage.getItem('skuId') && result === 1 ? false : true;
            });
        }).then(function () {
            return _this.getLearningPathSubItems(_this.learningPathMetaId).then(function (result) {
                console.log(result);
                return _this.learningPath = result;
            });
        }).then(function () {
            return _this.getUserQueryLearningProgress(_this.learningPathMetaId).then(function (result) {
                return _this.progressLists = result;
            });
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            return _this.getUserInfo().then(function (result) {
                return _this.user = result;
            });
        }).then(function () {
            return _this.getCourseitemsLock(_this.learningPathMetaId).then(function (result) {
                return _this.courseLockState = result;
            });
        }).then(function () {
            if (_this.isShowIntroduction) {
                _this.apiService.learingTime({ learningPathMetaId: _this.learningPathMetaId, module: _this.learningPath.name, courseUnit: '', type: 1, btnName: '课程介绍页', userId: localStorage.getItem("userId") }).subscribe(function (result) {
                    console.log(result);
                });
                // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入能力介绍页','userId':this.userId}).then();
            }
            _this.commonService.setCustomLockDate(_this.learningPath, Date());
            localStorage.setItem('companiesType', _this.user);
            if (_this.learningPathMetaId == 18 || _this.learningPathMetaId == 30 || _this.learningPathMetaId == 12 || _this.learningPathMetaId == 26 || _this.learningPathMetaId == 404) {
                _this.isShowBar = true;
                _this.canShow = true;
            }
            else {
                _this.isShowBar = _this.isShowIntroduction ? false : true;
                _this.canShow = _this.isShowIntroduction ? false : true;
            }
            _this.progressLists = _this.progressLists[_this.getIndexByConditionIdInLists(_this.progressLists, 'userId', _this.userId)];
            _this.learningPath.currentItemIndex = _this.progressLists.progressList[0].currentItemIndex;
            _this.progress = _this.progressLists.progressList[0].progress;
            var arr = _this.setSubItemsInfo(_this.learningPathMetaId);
            for (var i = 0, len = _this.learningPath.subItems.length; i < len; i += 1) {
                if (arr[i]) {
                    _this.learningPath.subItems[i].desc = arr[i][0];
                    _this.learningPath.subItems[i].time = arr[i][1];
                }
                else {
                    _this.learningPath.subItems[i].desc = "";
                    _this.learningPath.subItems[i].time = "";
                }
            }
            _this.mode = _this.learningPath.subItems.length > 3 ? 1 : 2;
            _this.learningPath.subItems.forEach(function (item) {
                _this.courseLockState.forEach(function (itm) {
                    if (item.type == itm.type) {
                        itm.openTime = _this.tansFromTimestamp(itm.openAt, 1);
                        itm.promptTime = _this.tansFromTimestamp(itm.openAt, 2);
                        item.courseLockdata = itm;
                    }
                });
            });
            //满意度调查显示逻辑
            //获取到用户相应能力满意度 （questionnaireInfo长度为0 || questionnaireInfo长度大于0 && isShow不等于1） &&情景模拟完成了 && 后测没有完成
            // this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.filter(d=>d.star === -1).length > 0)) && this.learningPath.subItems[this.getModuleIndex(4)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(3)].progress ===100 ? true : false;
            _this.isShowQuestionnaire = _this.questionnaireInfo && (_this.questionnaireInfo.length === 0 || (_this.questionnaireInfo.length > 0 && _this.questionnaireInfo.filter(function (d) { return d.star === -1; }).length > 0)) && _this.abilityStatus === 1 && _this.learningPath.currentItemIndex === 4 ? true : false;
            // 无后测版本逻辑
            // 是2019年6月18日以前注册的用户并且能力诊断未完成并且是之前完成过改课程的用户显示提示框
            // this.isShowTip = this.compareDate("2019-06-18", this.user.createdAt.split('T')[0]) && this.learningPath.subItems[this.getModuleIndex(1)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(2)].progress > 0 ? true : false;
            //团队训练营新逻辑
            if (localStorage.getItem('skuId')) {
                _this.canShow = false;
                _this.showCourse();
            }
            else {
                _this.canShow = true;
            }
        });
    };
    // 时间转化
    LearningProjectPathComponent.prototype.tansFromTimestamp = function (timestamp, type) {
        var date = new Date(timestamp);
        var Y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if (type == 1) {
            return M + "." + D;
        }
        else if (type == 2) {
            return Y + "-" + M + "-" + D + " " + h + ":" + m;
        }
    };
    //0启程 1辅导 2团队 11授权 12沟通 13组织 14协作 15影响力 16决策 18启程 20变革 22增强版影响力 24MAX 26TS 28冲突 30专业版影响力 201目标选才
    //402沟通 403授权 404领导力启程 405辅导 406 MAX 607影响力专业版
    LearningProjectPathComponent.prototype.setAssetsResults = function (learningPathMetaId) {
        var arr = {
            1: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            205: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            305: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            405: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            605: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            2: ['成为团队引路人', '找到团队问题的症结', '让团队更有凝聚力'],
            11: ['摆脱琐事，聚焦团队重点', '腾出时间，挑战更高的职涯目标', '培养良将，帮助下属发展'],
            403: ['摆脱琐事，聚焦团队重点', '腾出时间，挑战更高的职涯目标', '培养良将，帮助下属发展'],
            12: ['掌控沟通流程，提高互动效率', '辨识互动中的“情绪需求”', '提升互动沟通技巧'],
            402: ['掌控沟通流程，提高互动效率', '辨识互动中的“情绪需求”', '提升互动沟通技巧'],
            13: ['工作状态从容不迫', '工作安排井井有条', '团队管理忙而不乱'],
            14: ['完成既定目标任务', '成为内外部可信赖的伙伴', '建立长久的人脉关系'],
            15: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
            607: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
            16: ['掌握有效的决策路径', '规避阻碍决策的高危陷阱', '成为高质量的决策者'],
            318: ['掌握有效的决策路径', '规避阻碍决策的高危陷阱', '成为高质量的决策者'],
            18: ['领导者的思维模式', '领导者应有的自我修养', '了解领导者的必备能力'],
            404: ['领导者的思维模式', '领导者应有的自我修养', '了解领导者的必备能力'],
            20: ['良好心态，应对工作中的变化', '成为受上级青睐的“开拓者”', '轻松带领团队，不惧外部风浪'],
            24: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            406: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            606: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            26: ['掌握识人标准', '提升面谈技巧', '快速辨识最佳候选人'],
            28: ['帮助矛盾双方达成一致', '及时避免冲突升级', '应对冲突，游刃有余'],
            30: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
        }[Number(learningPathMetaId)] || [];
        return arr;
    };
    //设置新的信息
    //1辅导 2团队 11授权 12基础版沟通 13组织 14协作 15影响力 607影响力专业版 16决策 18启程 20变革 22增强版影响力 24MAX 26TS 28冲突 30专业版影响力
    //201目标选才 202标准版沟通 402沟通 403授权 404领导力启程 405辅导 406 MAX 607影响力专业版
    LearningProjectPathComponent.prototype.setSubItemsInfo = function (learningPathMetaId) {
        return {
            1: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            205: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            305: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            405: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            605: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            2: [['带领团队，你的优势与风险？', '预计时长：10分钟'], ['9个单元，学习团队成功要素', '预计时长：45分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            11: [['了解你的授权能力现状', '预计时长：10分钟'], ['7个单元，破解授权挑战', '预计时长：30分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            403: [['了解你的授权能力现状', '预计时长：10分钟'], ['7个单元，破解授权挑战', '预计时长：30分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            12: [['10个单元，学习领导者的经典沟通技巧', '预计时长：60分钟']],
            13: [['了解你的能力优势与风险', '预计时长：10分钟'], ['6个单元，掌握计划与组织要领', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            14: [['与他人协作，你的现状如何？', '预计时长：10分钟'], ['6个单元，帮你找到协作最优解', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            15: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            607: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            16: [['了解你的决策现状', '预计时长：10分钟'], ['7个单元，教你如何有效决策', '预计时长：35分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            18: [['开启你的领导力之旅', '预计时长：25分钟']],
            404: [['开启你的领导力之旅', '预计时长：25分钟']],
            20: [['了解你的变革指数', '预计时长：10分钟'], ['7个单元，加速你的变革', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            309: [['了解你的变革指数', '预计时长：10分钟'], ['7个单元，加速你的变革', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            318: [['了解你的决策现状', '预计时长：10分钟'], ['7个单元，教你如何有效决策', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            24: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            406: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            606: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：120分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            26: [['8个单元，面试技巧全知道', '预计时长：80分钟']],
            28: [['了解自己：你善于应对冲突吗？', '预计时长：10分钟'], ['5个单元， 让“冲突”不再是难题', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            30: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            201: [['了解你的“识人”水准', '预计时长：10分钟'], ['9个单元，面试技巧全知道', '预计时长：80分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            202: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            402: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']]
        }[learningPathMetaId] || [];
    };
    //根据条件在数组中获取下标
    LearningProjectPathComponent.prototype.getIndexByConditionIdInLists = function (Lists, condition, value) {
        return (Lists || []).findIndex(function (v) { return v[condition] === value; });
    };
    //查询能力模块信息
    LearningProjectPathComponent.prototype.getLearningPathSubItems = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/learningpathes/' + learningPathMetaId,
        }).toPromise();
    };
    //查询用户学习进度
    LearningProjectPathComponent.prototype.getUserQueryLearningProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    //控制测,学,练,考是否锁住
    LearningProjectPathComponent.prototype.getCourseitemsLock = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/itemsLock/' + String(learningPathMetaId) + '?projectId=' + this.projectId,
        }).toPromise();
    };
    //查询用户相应能力满意度
    LearningProjectPathComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    //获取模块位于learningPathSubItem里的下标
    LearningProjectPathComponent.prototype.getModuleIndex = function (value) {
        return this.learningPath.subItems.map(function (item) { return item.type; }).indexOf(value);
    };
    // 根据learningPathMetaId创建或者获取LearningPath
    LearningProjectPathComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/' + learningPathMetaId
        }).toPromise();
    };
    //获取用户信息
    LearningProjectPathComponent.prototype.getUserInfo = function () {
        return this.apiService.getUserInfo().toPromise();
    };
    // 比较日期大小
    LearningProjectPathComponent.prototype.compareDate = function (d1, d2) {
        var constDate = new Date(d1);
        var date = new Date(d2);
        return constDate.getTime() > date.getTime() ? true : false;
    };
    // 关闭问卷
    LearningProjectPathComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    /* 获取第三方公司返回 */
    LearningProjectPathComponent.prototype.isShowBackBtn = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/exposeoutapi/getAbilityBack'
        }).subscribe(function (result) {
            _this.abilityBack = result.data.abilityBack;
        });
    };
    LearningProjectPathComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    // 返回项目课程列表页面
    LearningProjectPathComponent.prototype.goToLearningProject = function () {
        if (this.customerBackUrl) {
            console.log(1111);
            location.href = this.customerBackUrl;
        }
        else {
            console.log(2222);
            this.router.navigate(['learning-project', this.projectId]);
        }
    };
    LearningProjectPathComponent.prototype.hideTip = function () {
        $("#shade").fadeOut();
        $('#tip').fadeOut();
    };
    LearningProjectPathComponent.prototype.hideTip2 = function () {
        $("#shade2").fadeOut();
        $('#tip2').fadeOut();
    };
    LearningProjectPathComponent.prototype.try = function () {
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningProjectPathComponent.prototype.mban = function () {
        if (this.status != 1) {
            console.log("点击");
            this.mengban = false;
        }
    };
    LearningProjectPathComponent.prototype.shiyong = function () {
        this.mengban = false;
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningProjectPathComponent.prototype.closeTip = function () {
        this.mengban = false;
    };
    LearningProjectPathComponent.prototype.cardClick = function (i) {
        var type = this.learningPath.subItems[i].type;
        //开始记录各能力模块学习时长
        // localStorage.setItem("learningPathMetaId-moduleId",type + "");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/' + type
        }).subscribe(function (result) { });
        if (type == 0) {
            this.showVector();
        }
        else if (type == 1) {
            this.showPreSurvey();
        }
        else if (type == 2) {
            this.showCourse();
        }
        else if (type == 3) {
            this.showPractice();
        }
        else if (type == 4) {
            this.showPostSurvey();
        }
        // if(this.learningPath.currentItemIndex<i){
        //   $("#toast1").fadeIn(500,function () {
        //     setTimeout(function () {
        //       $("#toast1").fadeOut(800);
        //     },800);
        //   });
        // }else{
        //   let type = this.learningPath.subItems[i].type;
        //   //开始记录各能力模块学习时长
        //   // localStorage.setItem("learningPathMetaId-moduleId",type + "");
        //   this.apiService.ajax({
        //     'type':'GET',
        //     'url':'/sr/exposeoutapi/setAbilitySession/'+this.learningPathMetaId+'/'+type
        //   }).subscribe(result=>{});
        //
        //   if(type==0){
        //     this.showVector();
        //   }else if(type==1){
        //     this.showPreSurvey();
        //   }else if(type==2){
        //     this.showCourse();
        //   }else if(type==3){
        //     this.showPractice();
        //   }else if(type==4){
        //     this.showPostSurvey();
        //   }
        // }
    };
    LearningProjectPathComponent.prototype.showVector = function () {
        if (this.status == 4 || this.status == 3) {
            var link = ['vector', this.learningPathId];
            this.router.navigate(link);
        }
        else if (this.learningPath.currentItemIndex >= 0 && this.status == 1) {
            var link = ['vector', this.learningPathId];
            this.router.navigate(link);
        }
    };
    // 跳转前测
    LearningProjectPathComponent.prototype.showPreSurvey = function () {
        var surveyMetaId, itemIndex;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 1) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index + 1;
                if (item.version) {
                    version = item.version;
                }
            }
        });
        // if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1){
        if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[0].openAt) || (this.learningPath.subItems[0].openAt && !this.learningPath.subItems[0].isLock) && this.status == 1 || (this.status == 4 || this.status == 3)) {
            if (this.learningPath.status == 0) {
                this.apiService.updateLearningPathStatus(String(this.learningPathId)).subscribe(function (result) {
                });
            }
            var link = ['survey', this.learningPathId, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 1];
            }
            this.router.navigate(link, {
                queryParams: {
                    abilityName: this.learningPath.name,
                    projectId: this.projectId,
                }
            });
            if (this.learningPath.subItems[itemIndex].courseLockdata.lockType == 1) {
                var projectmsg = {
                    lock: this.learningPath.subItems[itemIndex].courseLockdata.lock,
                    promptTime: this.learningPath.subItems[itemIndex].courseLockdata.promptTime
                };
                localStorage.setItem('projectmsg', JSON.stringify(projectmsg));
            }
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[0].openAt) || (this.learningPath.subItems[0].openAt && this.learningPath.subItems[0].isLock)) {
            this.showToast();
        }
    };
    // 跳转课程学习
    LearningProjectPathComponent.prototype.showCourse = function () {
        var courseId, itemIndex, promptTxt;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 2) {
                courseId = item.id;
                itemIndex = index + 1;
                if (item.courseLockdata.lockType == 1) {
                    promptTxt = "\u8BFE\u7A0B\u5B66\u4E60\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                    console.log(promptTxt);
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        if (this.status == 3 || this.status == 4) {
            var link = ['course', this.learningPathId, courseId];
            this.router.navigate(link, {
                queryParams: {
                    projectId: this.projectId
                }
            });
        }
        else {
            if (this.learningPath.subItems[itemIndex - 1].courseLockdata.lock) {
                this.showToast();
                return;
            }
            if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) || this.status != 1) {
                var link = ['course-new', this.learningPathId, courseId];
                this.router.navigate(link, {
                    queryParams: {
                        projectId: this.projectId
                    }
                });
            }
            else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
                this.showToast();
            }
        }
    };
    LearningProjectPathComponent.prototype.showIntroduction = function () {
        this.isShowIntroduction = true;
        this.flag = true;
    };
    // 跳转情景模拟
    LearningProjectPathComponent.prototype.showPractice = function () {
        var practiceMetaId, practiceIndex, promptTxt;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 3) {
                practiceMetaId = item.practiceMetaId;
                practiceIndex = index + 1;
                if (item.courseLockdata.lockType == 1) {
                    promptTxt = "\u60C5\u666F\u6A21\u62DF\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                    console.log(promptTxt);
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        if (this.learningPathMetaId == 607) {
            practiceMetaId = 607;
        }
        if (this.learningPathMetaId == 30) {
            practiceMetaId = 16;
        }
        if (this.learningPathMetaId == 15) {
            practiceMetaId = 9;
        }
        if (this.learningPath.subItems[practiceIndex - 1].courseLockdata.lock) {
            this.showToast();
            return;
        }
        if ((this.learningPath.currentItemIndex >= practiceIndex && !this.learningPath.subItems[practiceIndex - 1].openAt) || (this.learningPath.subItems[practiceIndex - 1].openAt && !this.learningPath.subItems[practiceIndex - 1].isLock) || this.status != 1) {
            if (this.learningPathMetaId == 402) {
                this.router.navigate(['egret-practice-communicate', 40201]);
            }
            else {
                //转向情景列表
                console.log(this.learningPath.name, this.learningPathId);
                var link = this.abilityConfig.getPracticeLinkList(this.learningPath.name, this.learningPathId, practiceMetaId);
                if (link.length > 0) {
                    console.log("我跳转了");
                    this.router.navigate(link);
                }
            }
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < practiceIndex && !this.learningPath.subItems[practiceIndex - 1].openAt) || (this.learningPath.subItems[practiceIndex - 1].openAt && this.learningPath.subItems[practiceIndex - 1].isLock)) {
            this.showToast();
        }
    };
    // 跳转后测
    LearningProjectPathComponent.prototype.showPostSurvey = function () {
        var surveyMetaId, itemIndex, promptTxt;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 4) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index + 1;
                if (item.version) {
                    version = item.version;
                }
                if (item.courseLockdata.lockType == 1) {
                    promptTxt = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                    console.log(promptTxt);
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        // console.log(this.learningPath);
        if (this.learningPath.subItems[itemIndex - 1].courseLockdata.lock) {
            this.showToast();
            return;
        }
        if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) && this.status == 1) {
            var link = ['survey', this.learningPathId, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 2];
            }
            this.router.navigate(link);
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
            this.showToast();
        }
    };
    LearningProjectPathComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    LearningProjectPathComponent.prototype.exitTip = function () {
        this.isShowTip = false;
    };
    LearningProjectPathComponent.prototype.closeLearningPathIntroduction = function () {
        this.isShowIntroduction = false;
        this.isShowBar = true;
        this.canShow = true;
        // setTimeout(()=>{
        //   this.isShowBar = true;
        // },500);
        if (!this.flag) {
            this.apiService.learingTime({ learningPathMetaId: this.learningPathMetaId, module: this.learningPath.name, courseUnit: '', type: 2, btnName: '课程介绍页', userId: localStorage.getItem("userId") }).subscribe(function (result) {
                console.log(result);
            });
        }
    };
    return LearningProjectPathComponent;
}());
export { LearningProjectPathComponent };



// WEBPACK FOOTER //
// ./src/app/learning-project-path/learning-project-path.component.ts.pre-build-optimizer.js